import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useScrollToTop } from '../../hooks/useScrollToTop';
import { useSearchResultsPagination } from '../hooks/useSearchResultsPagination';
import { useSearchResultsQuery } from '../hooks/useSearchResultsQuery';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchResultsPaginator() {
  const params = useSearchParams();
  const {
    data
  } = useSearchResultsQuery();
  const {
    currentPage,
    pageCount
  } = useSearchResultsPagination();
  const scrollToTop = useScrollToTop();
  if (!data) return undefined;
  if (data.result.total === 0) return undefined;
  const queryType = params.get('queryType');

  // Show pagination when queryType is not present or is ELASTIC_SEARCH
  if (queryType && queryType !== 'ELASTIC_SEARCH') return undefined;
  return /*#__PURE__*/_jsx(Paginator, {
    "data-test-id": "search-results-paginator",
    marginBlockStart: "800",
    page: currentPage,
    pageCount: pageCount,
    onPageChange: e => {
      params.set('page', e.target.value.toString(), {
        defaultValue: '1'
      });
      scrollToTop();
    }
  });
}